import { PnlModalProps } from 'src/components/Modals/PnlModal/types';
import usePnlModal from 'src/components/Modals/PnlModal/hooks/usePnlModal';
import PnlModalMobile from 'src/components/Modals/PnlModal/PnlModalMobile';
import PnlModalDesktop from 'src/components/Modals/PnlModal/PnlModalDesktop';

function PnlModal(props: PnlModalProps) {
	const {
		backgroundImagePathIndex,
		setBackgroundImagePathIndex,
		showCollateral,
		setShowCollateral,
		isMobileScreenSize,
		imageGenerationNodeRef,
		handleDownload,
		handleClose,
		handleCloseMobileDrawer,
		isMobileDrawerClosing,
		isDownloading,
		handleCopy,
		isCopying,
		isCopied,
		cardPreviewVariantProps,
	} = usePnlModal(props);

	if (isMobileScreenSize) {
		return (
			<PnlModalMobile
				backgroundImagePathIndex={backgroundImagePathIndex}
				setBackgroundImagePathIndex={setBackgroundImagePathIndex}
				showCollateral={showCollateral}
				setShowCollateral={setShowCollateral}
				imageGenerationNodeRef={imageGenerationNodeRef}
				handleCloseMobileDrawer={handleCloseMobileDrawer}
				isMobileDrawerClosing={isMobileDrawerClosing}
				handleDownload={handleDownload}
				isDownloading={isDownloading}
				handleCopy={handleCopy}
				isCopying={isCopying}
				isCopied={isCopied}
				cardPreviewVariantProps={cardPreviewVariantProps}
			/>
		);
	}

	return (
		<PnlModalDesktop
			handleClose={handleClose}
			backgroundImagePathIndex={backgroundImagePathIndex}
			setBackgroundImagePathIndex={setBackgroundImagePathIndex}
			imageGenerationNodeRef={imageGenerationNodeRef}
			showCollateral={showCollateral}
			setShowCollateral={setShowCollateral}
			handleDownload={handleDownload}
			isDownloading={isDownloading}
			handleCopy={handleCopy}
			isCopying={isCopying}
			isCopied={isCopied}
			cardPreviewVariantProps={cardPreviewVariantProps}
		/>
	);
}

export default PnlModal;
